export default __webpack_public_path__ + "static/urbansitter-f0c68099fca92c7c5fc4639490985847.png";